import {CategorySelectorDropdown} from '@frontend/modules/public/ads/components/search/CategorySelectorDropdown'
import {CategorySelectorModal} from '@frontend/modules/public/ads/components/search/CategorySelectorModal'
import {LocationSelector} from '@frontend/modules/public/ads/components/search/LocationSelector'
import {
    useAdsStore,
    useUiLayoutStore,
} from '@frontend/stores'
import {Collapse} from 'swayok-react-mdb-ui-kit/components/Collapse/Collapse'
import {ItemsSearchKeywordsInput} from './ItemsSearchKeywordsInput'

// Панель поиска объявлений.
export function ItemsSearchPanel() {

    const show = useAdsStore(
        state => state.searchPanel
    )

    const uiLayout = useUiLayoutStore(
        state => state.deviceType
    )

    const bootstrapSize = useUiLayoutStore(
        state => state.bootstrapSize
    )

    const isMobileMode: boolean = uiLayout === 'mobile' || bootstrapSize === 'md'

    return (
        <Collapse
            show={show}
            showImmediately
        >
            <div id="offered-items-filter">
                <div className="inner-container d-flex flex-row align-items-stretch justify-content-start">
                    {isMobileMode ? (
                        <CategorySelectorDropdown iconMode />
                    ) : (
                        <CategorySelectorModal />
                    )}
                    <ItemsSearchKeywordsInput
                        buttonMode={isMobileMode ? 'floating-icon' : 'icon'}
                    />
                    <LocationSelector iconMode={isMobileMode} />
                </div>
            </div>
        </Collapse>
    )
}
